import { useState, useEffect } from "react";
import {
  Box,
  Typography,
  IconButton,
  Button,
  Avatar,
  useTheme,
  useMediaQuery,
  Chip,
} from "@mui/material";
import { motion, AnimatePresence } from "framer-motion";
import ChatIcon from "@mui/icons-material/Chat";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";

const FloatingChat = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [isVisible, setIsVisible] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);
  console.log(isExpanded, isVisible);
  const fullMessage =
    "Hi👋, I'm Blossom from Blossom City Cleaning Services! How may I help you today?";

  useEffect(() => {
    // Show chat bubble after 3 seconds
    const timer = setTimeout(() => {
      setIsVisible(true);
      setIsExpanded(true);
    }, 5000);

    return () => clearTimeout(timer);
  }, []);

  const handleDismiss = () => {
    setIsExpanded(false);
  };

  const handleChatClick = () => {
    // // setIsVisible(true);
    // setIsVisible((prev) => !prev);
    setIsExpanded(true);
  };

  const handleChatNowClick = () => {
    window.open(
      "https://wa.me/256752058190?text=Hi%20Blossom!%20I%20saw%20your%20website%20and%20I%27d%20like%20to%20learn%20more%20about%20your%20cleaning%20services.",
      "_blank"
    );
  };

  if (!isVisible) return null;

  return (
    <Box
      sx={{
        position: "fixed",
        bottom: 24,
        right: 24,
        zIndex: 999,
      }}
    >
      {/* <Button
        onClick={handleChatClick}
        sytle={{ top: "50px", marginBottom: "10px" }}
      >
        click me
      </Button> */}
      {/* <AnimatePresence> */}
      {isExpanded ? (
        <motion.div
          initial={{ opacity: 0, scale: 0.8, y: 20 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          exit={{ opacity: 0, scale: 0.8, y: 20 }}
          transition={{ duration: 0.3, type: "spring", stiffness: 300 }}
        >
          {/* Chat Bubble */}
          <Box
            sx={{
              background: "white",
              borderRadius: 3,
              boxShadow: "0 20px 60px rgba(0,0,0,0.25)",
              border: "1px solid rgba(0,0,0,0.08)",
              maxWidth: isMobile ? 380 : 400,
              mb: 2,
              overflow: "hidden",
              position: "relative",
              backdropFilter: "blur(10px)",
            }}
          >
            {/* Header */}
            <Box
              sx={{
                background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                p: 2.5,
                display: "flex",
                alignItems: "center",
                gap: 2,
                position: "relative",
              }}
            >
              <Box sx={{ position: "relative" }}>
                <Avatar
                  src="https://images.unsplash.com/photo-1554151228-14d9def656e4?w=150&h=150&fit=crop&crop=face"
                  sx={{
                    width: 48,
                    height: 48,
                    border: "3px solid rgba(255,255,255,0.3)",
                    boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                  }}
                />
                {/* Online Status Indicator */}
                <Box
                  sx={{
                    position: "absolute",
                    bottom: 2,
                    right: 2,
                    width: 14,
                    height: 14,
                    backgroundColor: "#4CAF50",
                    border: "2px solid white",
                    borderRadius: "50%",
                  }}
                />
              </Box>
              <Box>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                    mb: 0.5,
                  }}
                >
                  <Typography
                    variant="h6"
                    sx={{
                      color: "white",
                      fontWeight: 700,
                      fontSize: "1.1rem",
                    }}
                  >
                    Blossom
                  </Typography>
                  <Chip
                    icon={<FiberManualRecordIcon sx={{ fontSize: 12 }} />}
                    label="Online"
                    size="small"
                    sx={{
                      backgroundColor: "rgba(255,255,255,0.2)",
                      color: "white",
                      fontWeight: 600,
                      fontSize: "0.7rem",
                      height: 24,
                      "& .MuiChip-icon": {
                        color: "#4CAF50",
                      },
                    }}
                  />
                </Box>
                <Typography
                  variant="caption"
                  sx={{
                    color: "rgba(255,255,255,0.9)",
                    fontWeight: 500,
                  }}
                >
                  Customer Support
                </Typography>
              </Box>
            </Box>

            {/* Message Content */}
            <Box sx={{ p: 3 }}>
              <Box
                sx={{
                  background:
                    "linear-gradient(135deg, #f8f9ff 0%, #f0f2ff 100%)",
                  borderRadius: 2,
                  p: 2.5,
                  mb: 3,
                  border: "1px solid rgba(102, 126, 234, 0.1)",
                  position: "relative",
                }}
              >
                <Typography
                  variant="body1"
                  sx={{
                    color: "text.primary",
                    lineHeight: 1.6,
                    fontWeight: 500,
                  }}
                >
                  {fullMessage}
                </Typography>

                {/* Message Tail */}
                <Box
                  sx={{
                    position: "absolute",
                    bottom: -8,
                    left: 20,
                    width: 0,
                    height: 0,
                    borderLeft: "8px solid transparent",
                    borderRight: "8px solid transparent",
                    borderTop: "8px solid #f8f9ff",
                  }}
                />
              </Box>

              {/* Buttons - Always Visible */}
              <Box
                sx={{
                  display: "flex",
                  gap: 2,
                  flexWrap: "nowrap",
                }}
              >
                <Button
                  variant="outlined"
                  onClick={handleDismiss}
                  size="medium"
                  sx={{
                    flex: 1,
                    borderRadius: 2,
                    textTransform: "none",
                    fontWeight: 600,
                    borderColor: "grey.300",
                    color: "text.secondary",
                    py: 1.2,
                    fontSize: "0.9rem",
                    minWidth: "120px",
                    "&:hover": {
                      borderColor: "grey.400",
                      backgroundColor: "grey.50",
                      transform: "translateY(-1px)",
                    },
                    transition: "all 0.3s ease",
                  }}
                >
                  Dismiss
                </Button>
                <Button
                  variant="contained"
                  onClick={handleChatNowClick}
                  size="medium"
                  startIcon={<WhatsAppIcon />}
                  sx={{
                    flex: 1,
                    background:
                      "linear-gradient(135deg, #25D366 0%, #128C7E 100%)",
                    borderRadius: 2,
                    textTransform: "none",
                    fontWeight: 700,
                    py: 1.2,
                    fontSize: "0.9rem",
                    minWidth: "140px",
                    boxShadow: "0 4px 15px rgba(37, 211, 102, 0.4)",
                    "&:hover": {
                      background:
                        "linear-gradient(135deg, #20BD5C 0%, #0F7A6A 100%)",
                      boxShadow: "0 6px 25px rgba(37, 211, 102, 0.5)",
                      transform: "translateY(-2px)",
                    },
                    transition: "all 0.3s ease",
                  }}
                >
                  Chat Now
                </Button>
              </Box>
            </Box>

            {/* Chat Bubble Tail */}
            <Box
              sx={{
                position: "absolute",
                bottom: -8,
                right: 20,
                width: 0,
                height: 0,
                borderLeft: "8px solid transparent",
                borderRight: "8px solid transparent",
                borderTop: "8px solid white",
              }}
            />
          </Box>
        </motion.div>
      ) : (
        // Floating Chat Button
        <motion.div
          initial={{ opacity: 0, scale: 0 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0 }}
          whileHover={{ scale: 1.1 }}
          whileTap={{ scale: 0.9 }}
          onClick={handleChatClick}
        >
          <IconButton
            sx={{
              background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
              color: "white",
              width: 64,
              height: 64,
              boxShadow: "0 8px 32px rgba(102, 126, 234, 0.4)",
              "&:hover": {
                background: "linear-gradient(135deg, #5a6fd8 0%, #6a4190 100%)",
                boxShadow: "0 12px 40px rgba(102, 126, 234, 0.6)",
              },
              transition: "all 0.3s ease",
              zIndex: 9999999,
              //   top: isMobile ? 16 : -74,
            }}
            onClick={handleChatClick}
          >
            <ChatIcon sx={{ fontSize: 28 }} />
          </IconButton>
        </motion.div>
      )}
      {/* </AnimatePresence> */}

      {/* Pulse Animation for Chat Button */}
      {/* {!isExpanded && (
        <motion.div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            borderRadius: "50%",
            border: "2px solid #667eea",
          }}
          animate={{
            scale: [1, 1.3, 1],
            opacity: [0.7, 0.3, 0.7],
          }}
          transition={{
            duration: 2,
            repeat: Infinity,
            ease: "easeInOut",
          }}
        />
      )} */}
    </Box>
  );
};

export default FloatingChat;
